var _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyloader2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spinnerLoaderRef",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    overflow: "visible",
    fill: "#ef395f",
    stroke: "none",
    className: "single-loader",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "spinner",
    x: 46.5,
    y: 45,
    width: 6,
    height: 14,
    rx: 2,
    ry: 2,
    transform: "translate(0 -30)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(45 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.125s",
    repeatCount: "indefinite"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.25s",
    repeatCount: "indefinite"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(135 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.375s",
    repeatCount: "indefinite"
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.5s",
    repeatCount: "indefinite"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(225 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.625s",
    repeatCount: "indefinite"
  }))), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.75s",
    repeatCount: "indefinite"
  }))), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#spinner",
    transform: "rotate(315 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.875s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyloader2);
export default __webpack_public_path__ + "static/media/myloader2.59dafa4000db28c1f377fc781d2ec07b.svg";
export { ForwardRef as ReactComponent };